import React from 'react';
import {ReactComponent as FaMLE} from '../svg/famle.svg';
import {ReactComponent as EarthPorn} from '../svg/earthporn.svg';
import {ReactComponent as NFL} from '../svg/nfl.svg';
import {ReactComponent as Network} from '../svg/network.svg';
import {ReactComponent as Scatter} from '../svg/scatter.svg';

const Projects = () =>
    <ul className="projects">
        <li id="famle">
            <a href="https://report.hmrfgrantresources.info/report" target="_blank" rel="noopener noreferrer">
                <FaMLE />
                <h3 className="name">FaMLE</h3>
                <p>Interactive Snapshots of Healthy Marriage and Responsible Fatherhood Grantees for the U.S. Department of Health and Human&nbsp;Services</p>
            </a>
        </li>
        <li id="earthporn">
            <a href="http://chrislindeman.com/earthporn">
                <EarthPorn />
                <h3 className="name">EarthPorn</h3>
                <p>hex-binned map with a bivariate color scheme to show popularity of photo locations posted on&nbsp;Reddit</p>
            </a>
        </li>
        <li id="nfl">
            <a href="http://chrislindeman.com/not-for-long">
                <NFL />
                <h3 className="name">Not For Long:
                <br />NFL Roster Continuity</h3>
                <p>data essay using canvas to allow for performant animated transitions of thousands of individual player-elements</p>
            </a>
        </li>
        <li id="network">
            <a href="http://chrislindeman.com/network">
                <Network />
                <h3 className="name">A Journey:<br />network diagram</h3>
                <p>force layout with custom arrow shapes to describe bidirectional paths through a decision&nbsp;tree</p>
            </a>
        </li>
        <li id="elite">
            <a href="http://chrislindeman.com/elite">
                <Scatter />
                <h3 className="name">Elite Advantage</h3>
                <p>brief analysis of the true cost of college using a filterable scatter plot and toggling&nbsp;metrics</p>
            </a>
        </li>
    </ul>

export default Projects;
